import { ChevronRightOutlineIcon } from '@ikyucom/design-system-icons-react'
import { useCallback } from 'react'
import type { RestaurantId } from '~/lib/graphql/scalars'
import { useReserveNavigate } from '~/navigation'
import { css, cx } from '~/styled-system/css'
import { center, hstack } from '~/styled-system/patterns'
import { calcMaxOffPrice } from './calcMaxOffPrice'
import { useDiscountCoupons } from './query'
import type { DiscountCoupons } from './query'

export function CouponBanner(props: { size: 'wide' | 'narrow'; restaurantId: RestaurantId }) {
  const coupons = useDiscountCoupons(props.restaurantId)

  const Banner = props.size === 'wide' ? WideCouponBanner : NarrowCouponBanner
  return <Banner coupons={coupons} />
}

function useShowCouponCallback(coupons: DiscountCoupons) {
  const navigate = useReserveNavigate()
  return useCallback(() => {
    navigate({ type: 'showCoupon' })
  }, [coupons, navigate])
}

function WideCouponBanner({ coupons }: { coupons: DiscountCoupons }) {
  const open = useShowCouponCallback(coupons)

  if (!coupons || coupons.length === 0) {
    return null
  }

  // PPGの場合は下に余白を追加
  const container = cx(
    center({ bgGradient: 'coupon', py: '3', w: 'full', cursor: 'pointer' }),
    import.meta.env.VITE_MODE === 'ppg' ? css({ mb: '3' }) : ''
  )

  return (
    <div onClick={open} className={container}>
      <div
        className={hstack({
          justifyContent: 'space-between',
          w: 'content.base',
        })}
      >
        <div
          className={css({
            fontSize: 'lg',
            color: 'white',
            border: 'light',
            borderRadius: 'full',
            px: '4',
            py: '1',
          })}
        >
          このレストランで使える
        </div>
        <span
          className={css({
            fontSize: '2xl',
            fontWeight: 'bold',
            lineHeight: 'none',
            color: 'white',
          })}
        >
          {coupons.length > 1 && '最大'}
          <span className={css({ fontSize: '4xl' })}>{calcMaxOffPrice(coupons)}</span>
          円OFFクーポン配布中！
        </span>
        <p
          className={css({
            fontSize: 'lg',
            fontWeight: 'bold',
            color: 'coupon.text',
            borderRadius: 'md',
            bgColor: 'white',
            px: '10',
            py: '2',
          })}
        >
          詳細はこちら
        </p>
      </div>
    </div>
  )
}

function NarrowCouponBanner({ coupons }: { coupons: DiscountCoupons }) {
  const open = useShowCouponCallback(coupons)

  if (!coupons || coupons.length === 0) {
    return null
  }
  return (
    <button
      type="button"
      onClick={open}
      className={center({
        bgGradient: 'coupon',
        py: '3',
        w: 'full',
        color: 'white',
        columnGap: '1',
        fontSize: 'xl',
        fontWeight: 'bold',
      })}
    >
      <span>
        {coupons.length > 1 && '最大'}
        {calcMaxOffPrice(coupons)}円OFFクーポンプレゼント
      </span>
      <ChevronRightOutlineIcon />
    </button>
  )
}
